import { useGetQuery } from '../../graphql';

export const useIssue = (issueId: string) => {
  const { data, isLoading } = useGetQuery({
    modelName: 'issue',
    query: GET_ISSUE,
    id: issueId,
  });

  return { issue: data, isLoading };
};

const GET_ISSUE = `
    query getIssue($id: ID!) {
      getIssue(id: $id) {
        id
        title
        type
        severity
        isPinned
        workspace {
          id
          name
        }
        asset {
          id
          name
          description
        }
        createdBy {
          id
          name {
            first
            last
          }
        }
        createdAt
        adjustCreationDate
        updatedAt
        routineVersion {
          config
          createdAt
          id
          order
          type
        }
        location {
          type
          coordinates
        }
        createdFrom
        createdFromAddress
        labels {
          id
          name
        }
        userMentions {
          id
          name {
            first
            last
          }
        }
        assetRoutine {
          id
          exceptionCount
          data
          routineVersion {
            id
            type
            config
          }
          createdAt
          createdBy {
            id
            name {
              first
              last
            }
          }
          routine {
            id
          }
        }
        onboarding {
          nextIssue
        }
      }
    }
`;
